export default "/list/static/images/eg-logo-blue.svg";